import React, { useState } from "react";

import Table from "./Table";
import Total from "./Total";

export default function Leaderboard() {
	const [show, setShow] = useState(false);

	return (
		<>
			<h3>2026-2027 Peer Group Leaderboard</h3>
			<button
				type="button"
				className="btn-alt"
				style={{ width: "auto", minHeight: "15px", padding: "5px 7.5px" }}
				onClick={() => setShow(!show)}
			>
				<i className={show ? "fa fa-minus-square-o" : "fa fa-plus-square-o"} />
				<span style={{ paddingLeft: "5px" }}>{show ? "Hide" : "Show"}</span>
			</button>

			<div
				className="peer-group-table-container"
				style={{ display: show ? "grid" : "none" }}
			>
				<Table peerGroup="A" />
				<Table peerGroup="B" />
				<Table peerGroup="C" />
				<Table peerGroup="D" />
				<Table peerGroup="E" />
				<Table peerGroup="F" />
				<Table peerGroup="G" />
				<Table peerGroup="H" />
				<Table peerGroup="I" />
				<Table peerGroup="J" />
				<Table peerGroup="K" />
				<Table peerGroup="L" />
			</div>

			<div style={{ display: show ? "block" : "none" }}>
				<Total />
			</div>

			<div className="list-spacer"></div>
		</>
	);
}
